import VuexPersistence from "vuex-persist";

const persistConfig = {
  vuexPersist: {
    // Key of the store
    key: "service-cloud",
    // Storage to save the store
    storage: window.sessionStorage,

    /**
     *  Add all the modules in the array to persist
     * @description Add name of the modules in the array
     * */
    modules: ["tickets", "contacts"],
  },
  vuexPersistAuth: {
    // Key of the store
    key: "mp.vx",
    // Storage to save the store
    storage: window.localStorage,

    /**
     *  Add all the modules in the array to persist
     * @description Add name of the modules in the array
     * */
    modules: ["auth","ui"],
  },
};

const scVuePersist = new VuexPersistence(persistConfig.vuexPersist);


const auth = new VuexPersistence(persistConfig.vuexPersistAuth);
export default {scVuePersist, auth};
